(function () {
  if (window.SwatchCart) return;

  window.SwatchCart = {
    addToCart: function (variantId) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      }).then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || 'Unable to add item');
          return d;
        });
      });
    },

    fetchCartVariantIds: function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          return new Set((cart.items || []).map(function (item) { return item.variant_id; }));
        });
    },

    refreshCartUi: function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.cart_count').forEach(function (el) { el.textContent = cart.item_count; });
          var container = document.querySelector('.cart-container');
          if (container) container.classList.add('active_link');
          document.dispatchEvent(new CustomEvent('order-swatches:cart-updated', { detail: { cart: cart } }));
        });
    },

    // Mark all buttons matching variantId as "Added" within root
    applyAddedState: function (root, variantId) {
      var id = String(variantId);
      // .os-atc — img-only button → replace textContent (CSS hides img via .added)
      root.querySelectorAll('.os-atc[data-variant-id="' + id + '"]').forEach(function (btn) {
        btn.classList.add('added');
        btn.textContent = 'Added';
        btn.setAttribute('aria-disabled', 'true');
      });
      // .os-add-swatch-cart — has <span> child
      root.querySelectorAll('.os-add-swatch-cart[data-variant-id="' + id + '"]').forEach(function (btn) {
        btn.classList.add('added');
        btn.disabled = true;
        var span = btn.querySelector('span');
        if (span) span.textContent = 'Added';
        else btn.textContent = 'Added';
      });
      // .sp-card__atc — text node directly, no <span>
      root.querySelectorAll('.sp-card__atc[data-variant-id="' + id + '"]').forEach(function (btn) {
        btn.classList.add('added');
        btn.disabled = true;
        btn.textContent = 'Added';
      });
    }
  };
})();
